import React from 'react'
import {connect} from "react-redux";
import {send_dccgen_cmd} from "../../etc/cmd";
import { CiPlug1 } from "react-icons/ci";
import {BIDIB_CS_STATE_GO, BIDIB_CS_STATE_GO_IGN_WD, BIDIB_CS_STATE_OFF} from "../bidib_commons";
const DccGen = ({node}) => {

    const dccgen = node || {}
    const dccgen_state = parseInt(dccgen.dccgen_state | 0)

    let st = "on"
    if( dccgen_state === 0x00) {
        st = "off"
    } else if( dccgen_state === 0x01 || dccgen_state === 0x02) {
        st = "stop"
    } else if( dccgen_state === 0x03) {
        st = "on"
    }

    let _st = ""
    switch(dccgen_state) {
        case 0x00:
            _st = "no DCC";
            break;
        case 0x01:
            _st = "DCC, all speed setting = 0";
            break;
        case 0x02:
            _st = "DCC, soft stop is progress";
            break;
        case 0x03:
            _st = "DCC on (watchdog is on)";
            break;
        case 0x04:
            _st = "DCC on (watchdog ignored)";
            break;
        case 0x08:
            _st = "in Programming Mode (ready for commands)";
            break;
        case 0x09:
            _st = "in Programming Mode (busy)";
            break;
        case 0x0D:
            _st = "busy";
            break;
        case 0xFF:
            _st = "query";
            break;
    }
/*
    BIDIB_CS_STATE_OFF            0x00  // no DCC, DCC-line is static, not toggling
    BIDIB_CS_STATE_STOP           0x01  // DCC, all speed setting = 0
    BIDIB_CS_STATE_SOFTSTOP       0x02  // DCC, soft stop is progress
    BIDIB_CS_STATE_GO             0x03  // DCC on (must be repeated if watchdog is on)
    BIDIB_CS_STATE_GO_IGN_WD      0x04  // DCC on (watchdog ignored)
    BIDIB_CS_STATE_PROG           0x08  // in Programming Mode (ready for commands)
    BIDIB_CS_STATE_PROGBUSY       0x09  // in Programming Mode (busy)
    BIDIB_CS_STATE_BUSY           0x0D  // busy
    BIDIB_CS_STATE_QUERY          0xFF
*/
    const onClick = (st) => {
        let cc = {
            id: dccgen.uid,
            state: st,
        }
        send_dccgen_cmd(cc);
    }

    const style = {
        color: 'black',
        backgroundColor: dccgen_state < 0x03 ? 'red' : 'rgb(151,175,109)',
        padding: 5,
        cursor: 'pointer',
    }
    const style2 = {
        ...style,
        backgroundColor: 'rgb(159,159,159)',
        width: '33%',
        marginLeft: 10,
    }
    const style3 = {
        ...style,
        width: '33%',
        cursor: 'default',
    }

    return (
        dccgen_state > 2 ?
            <div onClick={() => onClick(BIDIB_CS_STATE_OFF)} key={dccgen.uid} style={style}>
                <CiPlug1/> {_st}
            </div> :
        <div style={{
            display: "flex",
        }}>
            <div key={dccgen.uid} style={style3}>
                <CiPlug1/> {_st}
            </div>
            <div onClick={() => onClick(BIDIB_CS_STATE_GO)} style={style2}>
                GO
            </div>
            <div onClick={() => onClick(BIDIB_CS_STATE_GO_IGN_WD)} style={style2}>
                GO_IGN_WD
            </div>
        </div>
    );
}

// title={'' + dccgen.uid.slice(4) + " (" + dccgen.product + ") - " + st}

function mapStateToProps(state, other) {
    return {node: state.bidib.data.node.find(it =>it.uid === other.dccgenid)}
}

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(DccGen)